export const reports = {
  date: "Date",
  month: "Month",
  cancel: "Cancel",
  download: "Download",
  export: "Export",
  selectPeriod: "Select period",
  selectPayouts: "Select payout periods",
  dropdownLabel: "Date: {{selected}}",
  practitionerEarningsReport: {
    title: "Practitioner earnings report",
    content:
      "A helpful export for clinics with multiple Fullscript practitioners to assign revenue to each practitioner. Learn more about our <modelLink>compensation models</modelLink>.",
    compensationModelsLink: "compensation models",
    button: "Generate report",
    create: {
      title: "Create a practitioner earnings report",
      titleMobile: "Earnings report",
      stepper: {
        step1: "Compensation model",
        step2: "Payout periods",
        step3: "Review report",
      },
      step1: {
        title: "Select your clinic's compensation model",
        titleMobile: "Select compensation model",
        option1: {
          title: "{{patientTermCapitalize}} owner compensated",
          description:
            "Compensate practitioners for all products purchased by their {{patientTermPlural}}.",
          bulletPointsTitle: "How it works:",
          bulletPoints: [
            "Assign a {{patientTerm}} owner: Assign a practitioner to a {{patientTerm}} by editing the {{patientTerm}}'s information. This will designate a default payee for orders made by the {{patientTerm}}.",
            "Easy payee override: If needed, you can change the payee for an order without altering the {{patientTerm}} owner.",
            "Single payee per order: Each order will have a clear and singular payee, simplifying the compensation process.",
          ],
        },
        option2: {
          title: "Plan author compensated",
          description:
            "Compensate practitioners for recommended products purchased by {{patientTermPlural}}.",
          bulletPointsTitle: "How it works:",
          bulletPoints: [
            "If multiple practitioners recommend the same product to a {{patientTerm}}, the practitioner with the latest plan will receive compensation for that product.",
            'If a {{patientTerm}} orders products without any practitioner plan, those items will be listed as "Unassigned" in the report, but there will be indication of who the assigned practitioner is for that {{patientTerm}} so that compensation can be attributed.',
          ],
        },
        deprecated: {
          option1: {
            title: "{{patientTermCapitalize}} owner compensated",
            description:
              "Compensate practitioners for all products purchased by their {{patientTermPlural}}.",
            bulletPointsTitle: "How it works:",
            bulletPoints: [
              "Assign a {{ patientTerm }} owner: Designate a default payee for orders made by each {{ patientTerm }}.",
              "Easy payee override: If needed, you can change the payee for an order without altering the {{ patientTerm }} owner.",
              "Single payee per order: Each order will have a clear and singular payee, simplifying the compensation process.",
            ],
          },
          option2: {
            title: "Plan author compensated",
            description:
              "Compensate practitioners for recommended products purchased by {{patientTermPlural}}.",
            bulletPointsTitle: "How it works:",
            bulletPoints: [
              "If multiple practitioners recommend the same product to a {{patientTerm}}, the practitioner with the latest plan will receive compensation for that product.",
              'If a {{patientTerm}} orders products without any practitioner plan, those items will be listed as "Unassigned" in the report export, and no compensation will be attributed.',
            ],
          },
        },
        ctaLabel: "Next: Select earnings periods",
      },
      step2: {
        title: "Select payout period(s)",
        prefixText: "Year",
        createEarningsReport: "Create earnings report",
        downloadEarningsReport: "Download earnings report",
        emptyStateHeader: "No payout periods available",
        emptyStateBody:
          "Payout period options will appear as you receive orders from {{patientTermPlural}}.",
        selectPayoutPeriods: "Select payout period(s)",
        compensationModel: "Compensation model:",
        changeCompensationModel: "Change compensation model",
      },
      step3: {
        title: "Review payees and download earnings report",
        subtitle:
          "All orders in the selected payouts and all future orders by that {{patientTerm}} will have the selected practitioner as their default payee. The earnings report will be downloaded as an Excel file.",
        prefixText: "Practitioner",
        sku: "SKU",
        prescriber: "Prescriber",
        quantity: "Quantity",
        assignOrder: "Assign order",
        assignAllOrders: "Assign all orders",
        practitioners: "Prescribing practitioners",
        clinic: "Clinic",
        others: "Others",
        bonusProceeds: "Bonus proceeds:",
        downloadEarningsReport: "Download earnings report",
        toggleOrderDetails: "Toggle order details",
        date: "Date",
        amount: "Amount",
        returns: "Returns",
        cancellations: "Cancellations",
        successToast: "Order assigned successfully",
        successToastPlural: "Orders assigned successfully",
        paidInSeparatePeriod: "Paid in separate period",
        downloadWarning:
          "Not all orders have been assigned a payee. The earnings on any order without a payee will remain unassigned.",
        noneSelected: "None selected",
        noPayee: "No payee",
        assignedToFutureOrders:
          "{{-payeeName}} will be assigned to {{patientName}}'s future orders.",
        massAssignMessage:
          "Make payee the {{patientTerm}} owner? They will become the default payee for future orders by {{patientName}}.",
        massAssignCta: "Yes",
        singleAssignCta: "No, just this order",
        showHideDetails: "Show/hide details",
        choosePayee: "Choose payee",
        emptyStateHeader: "No payees found",
        emptyStateBody: "No payees found for the selected payout periods.",
      },
    },
    downloadSucessMessage: "Earnings report downloaded successfully.",
  },
  salesByProductReport: {
    title: "Sales by product report",
    description:
      "A monthly breakdown of product sales to help you understand the purchasing behaviour of your {{patientTermPlural}}.",
  },
};
